import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-16 pb-20 px-6 md:px-12 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-59">
      <motion.div className="flex-1 space-y-6" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-60">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight text-brand-green" data-id="element-61">
          Metabolismo 50+: El Reinicio de 7 Días
        </h1>
        <h2 className="text-xl md:text-2xl font-medium text-brand-rose italic" data-id="element-62">
          La estrategia de desinflamación biológica diseñada exclusivamente para
          la mujer hispana que siente que su cuerpo "se detuvo".
        </h2>
        <div className="prose prose-lg text-gray-700 font-body" data-id="element-63">
          <p data-id="element-64">
            Despiertas a las 6:30 AM y, antes de levantarte, ya sientes esa
            pesadez en las articulaciones. Te miras en el espejo y ves tu rostro
            hinchado. Vas al armario, intentas ponerte ese pantalón favorito que
            hace apenas tres meses te quedaba perfecto, y hoy el botón
            simplemente no llega.
          </p>
          <p data-id="element-65">
            No es que te falte voluntad. Tampoco es el postre de anoche. Lo que
            sucede es que, después de los 50, las reglas de tu cuerpo cambiaron
            y seguir usando dietas del pasado es como intentar apagar un
            incendio con gasolina.
          </p>
        </div>
        <div className="pt-6" data-id="element-66">
          <CTAButton data-id="element-67" />
        </div>
      </motion.div>

      <motion.div className="flex-1 w-full max-w-lg mx-auto flex items-center justify-center" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} data-id="element-68">
        <img src="https://cdn.magicpatterns.com/uploads/51qS5JT72AFxxFnQpRX96b/2da_imagen_del_nuevo_producto.png" alt="Metabolismo 50+ El Renacer" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-69" />
      </motion.div>
    </section>;
}